export default "__VITE_ASSET__wASjtPyJ__"